import {
    REFLECTION,
    REFLECTION_FEEDBACK, REFLECTION_FEEDBACK_HISTORY, REFLECTION_FEEDBACK_PROCESSING
} from '../actions/reflectionFeedback';


const initialState = {
    isLoading: false,
    likesList: [],
    isLiked: '',
    reflectionFeedback: [],
    commentList: [],
    errors: null,
    new: {
        isLoading: false,
        isSuccess: false,
        errors: null
    }
}

const reflectionFeedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case REFLECTION:
            return {
                ...state,
                reflectionFeedback: action.payload
            }
        case REFLECTION_FEEDBACK:
            return {
                ...state,
                new: {
                    isLoading: false,
                    isSuccess: false,
                    errors: action.errors
                }
            }
        case REFLECTION_FEEDBACK_HISTORY:
            return {
                ...state,
                reflectionFeedbackHisotry: action.payload
            }
        case REFLECTION_FEEDBACK_PROCESSING:
            return {
                ...state,
                reflectionFeedbackProcessing: action.payload
            }
        default:
            return state;
    }
};

export default reflectionFeedbackReducer;
